import ThrottleManager from './ThrottleMahager';

/**
 * ThrottleManager instance
 * */
const throttleManager = new ThrottleManager();

export default throttleManager;
